import { Button, Tooltip } from "@mui/material";
import { DataWrapper } from "../../../interfaces/DataWrapper";
import { PostPreference } from "../../../interfaces/PostPreference";
import classes from "./SaveFilters.module.scss";
import Notification from "../../../views/notification/Notification";
import { TipFilters } from "../../../interfaces/TipFilters";
import useSavePreference from "../../../hooks/useSavePreference";
import { SavePreferenceConfig } from "../../../interfaces/SavePreferenceConfig";
import { ContentLengthOptions } from "../../../enums/ContentLengthOptions";

const tipFiltersConfig: SavePreferenceConfig<TipFilters> = {
  buildPayload: (filters, userEmail): DataWrapper<PostPreference> => ({
    data: {
      name: buildPreferenceName(filters),
      tags: filters.tags?.map((tag) => tag.id) ?? [],
      types: [],
      sites: [],
      hasTips: false,
      user: userEmail,
      isForTipCollectionType: true,
      authors: filters.authors?.map((author) => author.id) ?? [],
      contentLength: filters.contentLength,
    },
  }),
  messages: {
    saveTooltip:
      "Save these Tip filters as a preference to receive notifications.",
    error: "An error occurred while saving tip preference!",
    success:
      "Tip preference saved! Go to profile page to subscribe for notifications.",
  },
};

const buildPreferenceName = (filters: TipFilters): string => {
  const parts = [];

  if (filters.tags && filters.tags.length > 0) {
    parts.push(
      `Tags: ${filters.tags.map((tag) => tag.attributes.name).join(", ")}`
    );
  }

  if (filters.authors && filters.authors.length > 0) {
    parts.push(
      `Authors: ${filters.authors
        .map((author) => author.attributes.name)
        .join(", ")}`
    );
  }

  if (filters.contentLength && filters.contentLength !== ContentLengthOptions.LONG) {
    parts.push(
      `Content Length: ${filters.contentLength}`
    );
  }

  return parts.length > 0 ? `${parts.join("; ")};` : "No filters;";
};

const SaveTipFilters = ({
  filters,
  hidden,
}: {
  filters: TipFilters;
  hidden: boolean;
}) => {
  const {
    savePreferenceHandler,
    isSaveButtonDisabled,
    isNotificationOpen,
    notificationMessage,
    notificationSeverity,
    notificationCloseHandler,
    tooltipMessage,
  } = useSavePreference<TipFilters>(filters, tipFiltersConfig);

  return (
    <>
      <Tooltip title={tooltipMessage}>
        <Button
          className={`${classes["save-button"]} mt-2 mt-sm-0`}
          disableElevation
          variant="contained"
          hidden={hidden}
          disabled={isSaveButtonDisabled}
          onClick={savePreferenceHandler}
        >
          Save Tip Filter
        </Button>
      </Tooltip>
      <Notification
        open={isNotificationOpen}
        onClose={notificationCloseHandler}
        message={notificationMessage}
        severity={notificationSeverity}
        position={{ vertical: "top", horizontal: "right" }}
      />
    </>
  );
};

export default SaveTipFilters;
